import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const logoutRoute: RouteConfig<'with-page'> = {
    name: 'Logout',
    path: '/account/logout',
    page: lazy(() => import('../../../../components/Logout')),
    flags: ['no-menu-item'],
}